/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-02-14 16:38:14
 * @LastEditTime: 2025-02-17 14:57:43
 * @LastEditors: ywj@originqc.com
 */

import request from '@/utils/request';

// banner和推荐位
export const getHappily = (): any =>
  request({
    url: 'product/happily.json',
  });

// 商品列表商品展示
export const getListData = (data:any): any =>
request({
  url: 'product/list.json',
  method: 'post',
  data
});